import React, { useEffect, useState } from 'react';
// mui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
// component
import AppHeader from '@/component/common/app-header';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import SFBottomNavigation from '@/component/common/sf-bottom-navigator';
import UserInfo from '@/component/common/user-info';
import BottomFix from '@/component/common/bottom-fix';
import { fontWeight } from '@/theme';
import CoinStatus from './CoinStatus';
import ChainList from './ChainList';
import ActionBtns from './ActionBtns';
import Dayjs from 'dayjs';
// lib & etc
import { SFPalette } from '@/lib/color';
import { useTranslation } from 'react-i18next';
import BannerList from '@/component/banner/BannerList';
// import SFRefreshIcon from '@/component/icons/sf-refresh-icon';
// import { boolean } from 'joi';

type BottomRefreshProps = {
  isRefresh: boolean;
  setIsRefresh: (value: boolean) => void;
};
export default function BottomRefresh(payload: BottomRefreshProps) {
  const { t } = useTranslation();
  // const { isRefresh, setIsRefresh } = payload;
  const nowTime = Dayjs().format('YYYY-MM-DD HH:mm:ss');
  return (
    <>
      <BottomFix enableHeight={false}>
        {/* <BannerList /> */}
        <Stack direction="row" mb={3.5} justifyContent="space-between" alignItems="center">
          {/* <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            sx={{
              borderRadius: '100px !important',
            }}
            fullWidth
            onClick={() => {
              document.location = 'https://tally.so/r/wg9q0P';
            }}
          >
            <Typography variant="h6" fontWeight={fontWeight.Bold}>
              이벤트 참여하기
            </Typography>
          </Button> */}

          <Stack direction="row" gap={1}>
            <Typography variant="subtitle2" color={SFPalette.lightGrey2}>
              <strong>{t('validation.marketInquiryTime')}</strong>
            </Typography>
            <Typography variant="subtitle2" color="#C4C4C4">
              {nowTime}
            </Typography>
          </Stack>
          <Stack spacing={2}>
            <Button
              variant="text"
              onClick={() => {
                document.location = 'https://pf.kakao.com/_DRxfMG';
              }}
            >
              {t('validation.ChatbotCs')}
            </Button>
          </Stack>
          {/* <Button
            onClick={() => {
              setIsRefresh(true);
            }}
          >
            <SFRefreshIcon color={SFPalette.grey3} />
          </Button> */}
        </Stack>
        <SFBottomNavigation selectedLabel={t('button.wallet')} />
      </BottomFix>
    </>
  );
}
